//QC Stages
export const GET_QC_STAGE = "GET_QC_STAGE";

// Compliance Category (SVM)
export const GET_COMPILANCE_CATEGORY = "GET_COMPILANCE_CATEGORY";
export const GET_COMPILANCE_SUB_CATEGORY = "GET_COMPILANCE_SUB_CATEGORY";
export const GET_COMPILANCE_SUB_CATEGORY_CATEGORY_FILTER =
  "GET_COMPILANCE_SUB_CATEGORY_CATEGORY_FILTER";

//Accounts-Master Compliance Item

export const GET_COMPILANCE_ITEM = "GET_COMPILANCE_ITEM";
export const GET_COMPLIANCE_ITEM_FILTER_COMPLIANCE_NAME =
  "GET_COMPLIANCE_ITEM_FILTER_COMPLIANCE_NAME";
export const GET_COMPLIANCE_ITEM__FILTER_CATEGORY =
  "GET_COMPLIANCE_ITEM__FILTER_CATEGORY";
export const GET_COMPLIANCE_ITEM__FILTER_COMPANY =
  "GET_COMPLIANCE_ITEM__FILTER_COMPANY";
export const GET_COMPLIANCE_ITEM_DETAIL = "GET_COMPLIANCE_ITEM_DETAIL";

//Accounts Compliance
export const GET_COMPILANCE = "GET_COMPILANCE";
export const GET_COMPLIANCE_FILTER_COMPANY = "GET_COMPLIANCE_FILTER_COMPANY";
export const GET_COMPLIANCE_FILTER_SUB_CATEGORY =
  "GET_COMPLIANCE_FILTER_SUB_CATEGORY";
export const GET_COMPLIANCE_FILTER_CATEGORY = "GET_COMPLIANCE_FILTER_CATEGORY";
export const GET_COMPLIANCE_DETAIL = "GET_COMPLIANCE_DETAIL";

// Accounts Company Compliance
export const GET_COMPANY_COMPLIANCE = "GET_COMPANY_COMPLIANCE";
export const GET_COMPANY_COMPLIANCE_FILTER_COMPANY =
  "GET_COMPANY_COMPLIANCE_FILTER_COMPANY";
export const GET_COMPANY_COMPLIANCE_DETAIL = "GET_COMPANY_COMPLIANCE_DETAIL";
